import styled from 'styled-components'

import { E_Colors } from '@/helpers/colors'


export const SC_Content = styled.div`
  padding: 20px 16px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const SC_FieldRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const SC_FieldLabel = styled.span`
  font-size: 14px;
  color: ${E_Colors.SystemGrey};
`

export const SC_FieldValue = styled.div`
  font-size: 16px;
  color: ${E_Colors.Black};
`

export const SC_CreditingTime = styled.span<{ $variant: 'fast' | 'slow' }>`
  && {
    color: ${({ $variant }) => (
      $variant === 'fast' ? E_Colors.Green : E_Colors.EraRed
    )};
  }
`
